import(/* webpackMode: "eager", webpackExports: ["columns"] */ "/vercel/path0/app/articles/@admin/columns.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DataTable"] */ "/vercel/path0/app/articles/@admin/data-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts/bebas-neue.ts\",\"import\":\"Bebas_Neue\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"bebasNeue\"}");
